import { StoreOrderProblemType } from '@/buyers/_gen/gql'
import { type StoreOrderProblem } from '@/dealers/_gen/gql'
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'
import { To } from 'react-router-dom'

import StoreOrderM from '@/dealers/modules/StoreOrder'

import Link from '@/gf/components/Link'

const StoreOrderProblem = ({
  problem,
  toContactCustomer,
}: {
  problem: Pick<StoreOrderProblem, 'type' | 'details'>
  toContactCustomer: To
}) => (
  <section className="rounded-lg py-2 px-3 border bg-red-50 border-red-200 text-red-900">
    <div className="flex gap-x-4 items-center">
      <div className="flex-grow">
        <h3 className="font-semibold text-lg leading-5">Problem with Order</h3>
        <div className="mt-2 flex flex-col gap-y-1 text-sm max-w-prose">
          {problem.type !== StoreOrderProblemType.Other && (
            <p className="font-medium">
              {StoreOrderM.getStoreOrderProblemTypeDisplay(problem.type)}
            </p>
          )}
          <p className="whitespace-pre-wrap leading-tight">{problem.details}</p>
        </div>
      </div>
      <Link.S className="flex flex-row items-center gap-x-1" to={toContactCustomer}>
        <ChatBubbleLeftRightIcon className="w-6 h-6 min-w-6 min-h-6 text-gray-600" /> Contact
        Customer
      </Link.S>
    </div>
  </section>
)

export default StoreOrderProblem
